.input {
  position: relative;
  box-sizing: border-box;
  font-family: Inter, sans-serif;
  font-size: 1.4rem;
  line-height: normal;
  padding:  0 1.2rem;
  transition: border 0.1s ease-in-out;
  background: var(--color-grayscale-tuna);
  border: 1px solid;
  border-radius: 0.4rem;
  height: 3.2rem;
  color: var(--color-grayscale-white);
  flex: 1;
  border-color: var(--color-grayscale-trout);
  font-weight: 400;
  margin: 0;

  &::placeholder {
    color: var(--color-grayscale-light-slate);
  }

  &:focus {
    border-color: var(--color-secondary);
  }

  &:invalid {
    border-color: var(--color-error);
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  appearance: textfield;
}
